// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"QrCode_qrCode__2GsU_","loadingDots":"QrCode_loadingDots__3nXPR"};